import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import client from "@/lib/api";

export default function PublicProfile() {
  const { nickname } = useParams();
  const [p, setP] = useState(undefined);
  useEffect(() => { client.get(`/u/${nickname}`).then((r) => setP(r.data)).catch(() => setP(null)); }, [nickname]);

  if (p === undefined) return <div className="min-h-[50vh]" />;
  if (p === null) return (
    <div className="max-w-xl mx-auto px-6 py-24 text-center" data-testid="profile-not-found">
      <h1 className="font-display text-3xl font-bold">Profile not found</h1>
      <p className="text-zinc-400 mt-2">This member doesn't exist or keeps their profile private.</p>
    </div>
  );
  return (
    <div className="max-w-3xl mx-auto px-5 sm:px-8 py-16" data-testid="public-profile">
      <div className="flex items-center gap-6">
        <div className="w-24 h-24 rounded-2xl overflow-hidden border border-white/10 bg-white/5 shrink-0">
          {p.avatar ? <img src={p.avatar} alt="" className="w-full h-full object-cover" />
            : <div className="w-full h-full grid place-items-center font-display text-3xl text-[#ccff00]">{p.nickname[0].toUpperCase()}</div>}
        </div>
        <div className="min-w-0">
          <h1 className="font-display text-4xl sm:text-5xl font-black truncate" data-testid="profile-nickname-heading">@{p.nickname}</h1>
          <p className="text-zinc-300 mt-1">{p.display_name}</p>
          <p className="text-xs font-mono-cl tracking-[0.14em] uppercase text-zinc-500 mt-2">{p.public_id} · Joined {p.joined}{p.wallet ? ` · ${p.wallet}` : ""}</p>
        </div>
      </div>
      {p.bio && <p className="text-zinc-300 mt-8 leading-relaxed max-w-xl" data-testid="profile-bio-text">{p.bio}</p>}
      {p.analyst_slug && <Link to={`/analyst/${p.analyst_slug}`} className="inline-block mt-6 text-sm text-[#ccff00] hover:underline">View analyst research</Link>}
      {p.analysts?.length > 0 && (
        <div className="mt-10">
          <p className="text-xs font-mono-cl tracking-[0.14em] uppercase text-zinc-500 mb-3">Follows</p>
          <div className="flex flex-wrap gap-3">
            {p.analysts.map((a) => (
              <Link key={a.slug} to={`/analyst/${a.slug}`} className="flex items-center gap-2 px-3 py-2 rounded-full border border-white/10 hover:border-[#ccff00]/50 text-sm">
                {a.profile_image && <img src={a.profile_image} alt="" className="w-6 h-6 rounded-full object-cover" />}{a.name}
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
